import moment, { ISO_8601 } from 'moment';

const employees = [];

const circles = [];

const gpsData = [];

const allocations = [];
const regions = [
  { id: null, name: 'Alle regioner' }, 
  {id: "syd", name: "syd"}, 
  {id: "nord", name: "nord"}, 
  //{id: "begge", name: "begge"}
];

const allocationTypes = [
  { key: 'TIMEOFF', label: 'Afspadsering', shortName: 'Afs', isVisible: true },
  { key: 'WORK', label: 'Arbejde', shortName: 'Arb', isVisible: true },
  { key: 'WORKINGSATURDAY', label: 'Arbejde lørdag', shortName: 'Arb', isVisible: false },
  { key: 'WORKINGSUNDAY', label: 'Arbejde søndag', shortName: 'Arb', isVisible: false },
  { key: 'WORKINGHOLIDAY', label: 'Arbejde helligdag', shortName: 'Arb', isVisible: false },
  { key: 'OTHER', label: 'Andet', shortName: 'And', isVisible: true },
  { key: 'FUNERAL', label: 'Begravelse', shortName: 'Beg', isVisible: true },
  { key: 'MATERNETY', label: 'Barsel', title: 'Barsel betalt af viking', shortName: 'Bar', isVisible: true },
  { key: 'VACATION', label: 'Ferie', shortName: 'Fer', isVisible: true },
  { key: 'ABSENCE', label: 'Fravær', shortName: 'Fra', isVisible: true },
  { key: 'OFFDAY', label: 'Fridag', shortName: 'Fri', isVisible: true },
  { key: 'OFFDAYREPLACEMENT', label: 'Ledig', shortName: 'Led', isVisible: false },
  { key: 'BIRTHDAY', label: 'Fødselsdage (rund fødselsdag)', shortName: 'Fød', isVisible: true },
  { key: 'WORKHOLEDAY', label: 'Heldagsarbejde  (husk bemærking eg. livestock)', shortName: 'Hel', isVisible: true },
  { key: 'HOLIDAY', label: 'Helligdag', shortName: 'Hel', isVisible: true },
  { key: 'ANNIVERSARY', label: 'Jubilæum mv.', shortName: 'Jub', isVisible: true },
  { key: 'MATERNETYNONPAID', label: 'Orlov', title: 'Orlov ikke betalt af viking', shortName: 'Orl', isVisible: true},
  { key: 'VACATIONSICKDAY', label: 'Sygdom under ferie', shortName: 'Syg Fer', isVisible: true },
  { key: 'SICKDAY', label: 'Sygedag', shortName: 'Syg', isVisible: true },
  { key: 'SICKDAYCHILD', label: 'Sygedag - Barnets første', shortName: 'Syg', isVisible: true },
  { key: 'SICKDAYWORK', label: 'Sygedag - Arbejdsrelateret', shortName: 'Syg', isVisible: true },
  { key: 'SICKDAYUNAVAILABLE', label: 'Sygedag - Ikke tilgængelig', shortName: 'Syg', isVisible: true },
  { key: 'SICKREPLACEMENT', label: 'Sygdomsafløsning', shortName: 'SAL', isVisible: true}
];

const forecasts = [];

const milestones = [];

const overAllocations = []

let groups = [];

export { circles, employees, allocations, allocationTypes, forecasts, milestones, overAllocations, groups, regions };